
export const camelize = function (str) {
  let arr = str.split("-");
  let capital = arr.map((item, index) =>
    index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item
  );
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString;
};

export const capitalize = function ([first, ...rest]) {
  return first.toUpperCase(first) + rest.join("");
};

export const dependenciesCheck = function () {
  var passed = true;

  for (var i = 0; i < arguments.length; i++) {
    var argBooleanValue = !!(typeof arguments[i] === "string" ||
    arguments[i] instanceof jQuery
      ? arguments[i].length
      : arguments[i]);
    passed = passed && argBooleanValue;
  }

  return passed;
};

export const isTouchDevice = function () {
  return (
    "ontouchstart" in window ||
    navigator.MaxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function () {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export const on = function (
  eventName,
  elementSelector,
  handler,
  parent = document
) {
  parent.addEventListener(
    eventName,
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (
        var target = e.target;
        target && target != this;
        target = target.parentNode
      ) {
        if (target.matches(elementSelector)) {
          handler.call(target, e);
          break;
        }
      }
    },
    false
  );
};

export const getCookie = function (cookieName) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};

export const isCountryInMarket = function (countryIsoCode = "") {
  let userSelectedCountry = getCookie("COUNTRY_SELECTED");

  if (countryIsoCode)
    if (
      window.Shopify &&
      window.dAgency.marketsConfiguration.marketsByCountry &&
      window.dAgency.marketsConfiguration.marketsByCountry[userSelectedCountry]
    ) {
      const userGeolocatedCountry = Shopify.country;
      const userGeolocatedMarket =
        window.dAgency.marketsConfiguration.marketsByCountry[
          userGeolocatedCountry
        ];
      const userMarket =
        window.dAgency.marketsConfiguration.marketsByCountry[
          userSelectedCountry
        ];

      return userGeolocatedMarket === userMarket;
    }
};

// COLLECTIONS PAGINATION HELPERS
export const attachProxyLinkEvent = function (requestURL) {
  var $proxyLinks = $("#AjaxinateContainer").find("[data-link-proxy]");

  if ($proxyLinks.length > 1) {
    $proxyLinks.off("click");
    $proxyLinks.ProxyLink({
      excludes: [
        ".slick-dots",
        ".product-tile__variant",
        ".swym-add-to-wishlist-view-product",
      ],
      onBeforeUnload: function ($proxyLink) {
        const itemID = $proxyLink.data("pid");

        if (itemID) {
          const requestedPageNum = requestURL
            .substr(requestURL.indexOf("?page="))
            .replace("?page=", "");

          var queryParams = new URLSearchParams(window.location.search);

          if (!isNaN(requestedPageNum)) {
            queryParams.set("i", requestedPageNum);
            queryParams.delete("page");
            history.pushState(
              null,
              "",
              "?" + queryParams.toString() + "#" + itemID
            );
          } else {
            history.pushState(
              null,
              "",
              "?" + queryParams.toString() + "#" + itemID
            );
          }
        }
      },
    });
  }
};

export const updatePagination = ($html) => {
  const pagination = $html.find("#ProductGridContainer .products-count").get(0);
  const pag_n = pagination.getAttribute("data-pagination");

  let paginationCount = document.querySelector(
    "#ProductGridContainer .products-count span"
  );

  if (paginationCount) {
    paginationCount.innerHTML = pag_n;
  }

  let paginationAncor = document.querySelector(
    "#AjaxinatePagination .pagination a"
  );

  if (paginationAncor) {
    paginationAncor.classList.remove("loading");
    paginationAncor.addEventListener("click", function (event) {
      event.target.classList.add("loading");
    });
  }
};

export const scrollToItem = ({ itemID, ajaxPageNumber, requestedPageNum }) => {
  const headersHeight = $(".site-header").outerHeight(true);
  const filterHeight = $(".js-mobile-filters-toggle").outerHeight(true);

  if (itemID && ajaxPageNumber == requestedPageNum) {
    if ($(itemID)) {
      var itemTop = $(itemID).offset().top - headersHeight - filterHeight;
      window.scrollTo({ left: 0, top: itemTop, behavior: "smooth" });
    }
  }
};

export const waitForElm = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

export const daysToEpoch = (days) => {
  const secondsPerDay = 24 * 60 * 60;
  const epochStart = new Date();
  const totalSeconds = days * secondsPerDay;
  const epochTime = epochStart.getTime() + totalSeconds * 1000; // Convert to milliseconds
  return epochTime;
};

export const setCookie = (name, value, daysToExpire) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + daysToExpire * 24 * 60 * 60 * 1000); // Convert days to milliseconds

  const cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )};expires=${expires.toUTCString()};path=/`;
  document.cookie = cookie;
};

export const isElementInVerticalViewport = (el) => {

  var rect = el.getBoundingClientRect();

  return (
    rect.bottom >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
};

export const findLastElementInViewport = (elements) => {
  for (var i = elements.length -1 ; i >= 0; i--) {
    if (isElementInVerticalViewport(elements[i])) {
      return elements[i];
    }
  }
  return null; // If no element is in the viewport
};


export const slickSliderRefresh = selector => {
  const slickSlider = $(selector);

  if(slickSlider && typeof slickSlider.slick == 'function') {
    slickSlider.slick('refresh');
  }
}

